/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useCallback, useEffect } from "react";
import { NotificationIndicatorForModule } from "src/components/atoms/NotificationIndicator";
import { NavigationModuleDropdownTemplateCardLinkList } from "src/components/molecules/TemplateCardLinkList";

import { ModuleId } from "src/globalTypes";
import useChangedStateOnOutsideClick from "src/utils/useChangedStateOnOutsideClick";
import {
  ArrowDown,
  Module,
  ModuleIcon,
  ModuleName,
  notificationIndicatorCss,
  RelativeContainer,
  TemplateCollapse,
} from "./styles";

type Props = {
  moduleId: ModuleId;
  moduleName: string;
  moduleIcon: string;
  closeNav: () => void; // Closes whole navbar on mobile
};

const ModuleDropdown = ({
  moduleId,
  moduleIcon,
  moduleName,
  closeNav,
}: Props) => {
  const { ref, setIsOpen, isOpen } =
    useChangedStateOnOutsideClick<HTMLLIElement>();

  const handleOnClickModule = () => {
    setIsOpen((prev) => !prev);
  };

  const boundMenuItemOnClickSideEffect = useCallback(() => {
    closeNav();
    setIsOpen(false);
  }, [setIsOpen, closeNav]);

  return (
    <RelativeContainer ref={ref}>
      <Module
        data-cy="choose-module"
        onClick={handleOnClickModule}
        isToggled={isOpen}
      >
        {moduleIcon && <ModuleIcon>{moduleIcon}</ModuleIcon>}
        <ModuleName>{moduleName}</ModuleName>
        <ArrowDown />
        <NotificationIndicatorForModule
          css={notificationIndicatorCss}
          moduleId={moduleId}
        />
      </Module>
      {isOpen && (
        <TemplateCollapse data-cy="template-collapse">
          <NavigationModuleDropdownTemplateCardLinkList
            moduleId={moduleId}
            onClickSideEffects={boundMenuItemOnClickSideEffect}
          />
        </TemplateCollapse>
      )}
    </RelativeContainer>
  );
};

export default ModuleDropdown;
export type ModuleDropDownProps = Props;
